import { render, staticRenderFns } from "./SupplierVerificationColumn.vue?vue&type=template&id=02f907e8&"
import script from "./SupplierVerificationColumn.vue?vue&type=script&lang=js&"
export * from "./SupplierVerificationColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports